module.exports = __webpack_public_path__ + "static/img/9.b21ba95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/online/9.jpg
// module id = MLVY
// module chunks = 0